import { ReactElement } from 'react';
import { CUSTOMER_SUPPORT_URL } from '../constants/routes';
import { CustomButton } from '../elements/button';
import { ReactComponent as SupportIcon } from '../assets/icons/SupportIcon.svg';
import { Button } from '@mui/material';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: any;
  title?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

export function CustomerSupportButton({
  onClick,
  title,
  children,
  style = {},
}: Props) {
  return (
    <a
      href={CUSTOMER_SUPPORT_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={style}
    >
      <Button
        onClick={onClick}
        style={{
          color: '#FFFFFF',
        }}
        startIcon={<SupportIcon />} // assumes the Button component supports `startIcon`
      >
        {title}
        {children}
      </Button>
    </a>
  );
}

